function Loop() {

    this.object = function(obj, callback) {
        var keys = Object.keys(obj);
        for (var i = 0; i < keys.length; i++) {
            (function(i) {
                callback(keys, i);
            })(i);
        }
    }

    this.array = function(array, callback, reverse) {
        if (reverse) {
            for (var i = array.length - 1; i > -1; i--) {
                (function(i) {
                    callback(array, i);
                })(i);
            }
        } else {
            for (var i = 0; i < array.length; i++) {
                (function(i) {
                    callback(array, i);
                })(i);
            }
        }
    }
}

!function(e,n){"function"==typeof define&&define.amd?define(["exports"],n):n("undefined"!=typeof exports?exports:e.dragscroll={})}(this,function(e){var n,t,o=window,l=document,c="mousemove",r="mouseup",i="mousedown",m="EventListener",d="add"+m,s="remove"+m,f=[],u=function(e,m){for(e=0;e<f.length;)m=f[e++],m=m.container||m,m[s](i,m.md,0),o[s](r,m.mu,0),o[s](c,m.mm,0);for(f=[].slice.call(l.getElementsByClassName("dragscroll")),e=0;e<f.length;)!function(e,m,s,f,u,a){(a=e.container||e)[d](i,a.md=function(n){e.hasAttribute("nochilddrag")&&l.elementFromPoint(n.pageX,n.pageY)!=a||(f=1,m=n.clientX,s=n.clientY,n.preventDefault())},0),o[d](r,a.mu=function(){f=0},0),o[d](c,a.mm=function(o){f&&((u=e.scroller||e).scrollLeft-=n=-m+(m=o.clientX),u.scrollTop-=t=-s+(s=o.clientY),e==l.body&&((u=l.documentElement).scrollLeft-=n,u.scrollTop-=t))},0)}(f[e++])};"complete"==l.readyState?u():o[d]("load",u,0),e.reset=u});
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (typeof exports === 'object' && typeof module !== 'undefined') {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


function Carousel(el) {
    var loop = new Loop();
    var self = this;

    this.el = el;

    this.init = function() {
        this.left = this.el.querySelector('button[data-direction="left"].js-carousel__control');
        this.right = this.el.querySelector('button[data-direction="right"].js-carousel__control');
        this.container = this.el.querySelector('.js-carousel__container');
        this.link = this.container.querySelectorAll(this.el.getAttribute('data-carousel-items'));
        this.thumbnail = this.el.querySelectorAll('.js-carousel__thumbnail');

        this.left.onclick = this.scrollLeft.bind(this);
        this.right.onclick = this.scrollRight.bind(this);

        this.oldMouseX = null;
        this.mouseX = null;
        this.mouseDown = false;
        this.clicked = false;
        this.activate = this.el.getAttribute('data-carousel-activate');
        this.snap = this.el.hasAttribute('data-carousel-snap');

        this.id = 0;

        this.controlClicked = false;
        this.controlByThumbnail = false;

        this.defineBreakpoints();
        this.checkBreakpoint();

        this.updateControls();
        this.watchScroll();
        this.watchForResize();
        this.checkIfThumbnailsExist();

        loop.array(this.thumbnail, function(array, i) {
            // Assign an ID to the thumbnail
            array[i].setAttribute('data-id', i);

            // If the thumbnail is clicked, update the carousel
            array[i].onclick = function(e) {
                e.preventDefault();
                self.id = this.getAttribute('data-id');
                self.controlClicked = true;
                self.scroll();
                self.updateThumbnails(this);
            }

            if (i == 0) {
                self.updateThumbnails(array[i]);
            }
        });

        loop.array(this.link, function(array, i) {
            // Assign an ID to the link
            array[i].setAttribute('data-id', i);

            // If the link is clicked, but was actually a drag, then prevent it
            array[i].onclick = function(e) {
                if (self.isValid()) {
                    if (!self.clicked) {
                        e.preventDefault();
                    }

                    self.clicked = false;
                }
            }

            // When the mouse is clicked, activate the mouseDown variable
            array[i].onmousedown = function(e) {
                if (self.isValid()) {
                    e.preventDefault();
                    self.mouseDown = true;
                }
            }

            // When the mouse is moved, updated the mouseX variable
            array[i].onmousemove = function(e) {
                if (self.isValid()) {
                    e.preventDefault();
                    if (self.mouseDown) {
                        self.mouseX = e.clientX;
                    }
                }
            }

            // When the mouse is released, if the mouseX has not changed, then trigger the click on the link
            array[i].onmouseup = function(e) {
                if (self.isValid()) {
                    e.preventDefault();
                    self.mouseDown = false;

                    if (self.oldMouseX == self.mouseX) {
                        self.clicked = true;
                        array[i].click();
                    }

                    self.oldMouseX = self.mouseX;
                }
            }

            // Scroll to the link when it is focussed
            array[i].onfocus = function() {
                if (self.isValid()) {
                    self.id = i;
                    self.scrollTo(this);
                    self.updateActive(true);
                }
            }

            // Unset the active state of the link when it is blurred
            array[i].onblur = function() {
                if (self.isValid()) {
                    self.unsetActive(this);
                }
            }
        });
    }

    // Check if the carousel is valid to be shown/interacted with
    this.isValid = function() {
        if (this.activate) {
            var breakpoint = Soho.breakpoints[Soho.sizes[this.activate]];

            return window.matchMedia('(' + breakpoint.type + ': ' + breakpoint.size + 'px)').matches;
        }
        return true;
    }

    // Scroll left
    this.scrollLeft = function() {
        this.animate(this.container.scrollLeft - (this.container.clientWidth - this.getContainerPadding()));
        this.controlClicked = true;
    }

    // Scroll right
    this.scrollRight = function() {
        this.animate(this.container.scrollLeft + (this.container.clientWidth - this.getContainerPadding()));
        this.controlClicked = true;
    }

    // Scroll to the active item
    this.scroll = function() {
        this.scrollTo(this.link[this.id]);
    }

    // Scroll to a given item
    this.scrollTo = function(el) {
        this.updateControls();

        if (this.container.scrollLeft + this.container.clientWidth == this.container.scrollWidth && !this.controlByThumbnail) {
            if (!self.controlByThumbnail) {
                this.resetFocus();
                if (self.controlClicked) {
                    this.disableFocus(true);
                    this.link[self.id].onfocus = function() {
                        self.scrollTo(this);
                        self.resetFocus();
                        self.updateActive(true);
                    }
                }
                self.controlClicked = false;
            }
        } else {
            this.container.scrollLeft = el.parentNode.offsetLeft - el.parentNode.parentNode.offsetLeft - this.getContainerPadding();
        }

        this.updateActive();
    }

    // Disable focus on all (or all BUT the active item) items
    this.disableFocus = function(ignoreActive) {
        loop.array(this.link, function(array, i) {
            if (!ignoreActive || (ignoreActive && i != self.id)) {
                array[i].setAttribute('tabIndex', -1);
            }
        });
    }

    this.resetFocus = function() {
        loop.array(this.link, function(array, i) {
            array[i].removeAttribute('tabIndex');
        });
    }

    // Unset the last active carousel item and set the new one
    this.updateActive = function(onfocus) {
        var active = this.link[self.id];
        if (onfocus) {
            active = document.activeElement;
        }
        loop.array(this.link, function(array, i) {
            self.unsetActive(array[i]);
        });

        this.setActive(active);
    }

    // Set the active carousel item
    this.setActive = function(el) {
        el.setAttribute('data-carousel-item-active', true);
    }

    // Unset the active carousel item
    this.unsetActive = function(el) {
        el.removeAttribute('data-carousel-item-active');
    }

    // Watch the carousel for scrolling
    this.watchScroll = function() {

        var timeout;

        this.container.onscroll = function() {
            var active = null;
            loop.array(self.link, function(array, i) {
                if (array[i].parentNode.offsetLeft - array[i].parentNode.clientWidth - self.getContainerPadding() < self.container.scrollLeft) {
                    active = array[i].getAttribute('data-id');
                }
            });

            self.id = parseInt(active);

            if (!self.controlByThumbnail) {
                self.resetFocus();
                self.disableFocus(true);
                self.link[self.id].onfocus = function() {
                    self.resetFocus();
                    self.updateActive(true);
                }
            }

            clearTimeout(timeout);
            timeout = setTimeout(function() {
                if (!self.controlClicked) {
                    self.resetFocus();
                    self.link[self.id].focus();
                } else {
                    self.controlClicked = false;
                }

                self.updateControls();

                if (self.snap) {
                    var center = self.container.offsetLeft + self.container.scrollLeft + (self.container.clientWidth / 2);

                    loop.array(self.link, function(array, i) {
                        if (center >= array[i].offsetLeft && center <= array[i].offsetLeft + array[i].clientWidth) {
                            if (self.container.scrollLeft !== array[i].offsetLeft) {
                                self.scrollTo(array[i]);
                                array[i].focus();
                                self.updateThumbnails(self.thumbnail[i]);
                            }
                        }
                    });
                }
            }, 100);
        }
    }

    // Update the state of the carousel controls
    this.updateControls = function() {
        if (this.container.scrollLeft == 0) {
            this.left.setAttribute('disabled', true);
        } else {
            this.left.removeAttribute('disabled');
        }
        if (this.container.scrollLeft + this.container.clientWidth == this.container.scrollWidth) {
            this.right.setAttribute('disabled', true);
        } else {
            this.right.removeAttribute('disabled');
        }
    }

    // Define the padding on the container
    this.getContainerPadding = function() {
        var data = JSON.parse(this.el.getAttribute('data-carousel-padding'));

        if (!data) {
            return;
        }

        var padding = false;
        var arithmetic = ['+', '-', '/', '*'];
        var units = ['px', 'vw', 'vh'];

        var fn = {
            px: function(value) {
                return parseInt(value.replace('px', ''));
            },
            vw: function(value) {
                return (window.innerWidth / 100) * parseInt(value.replace('vw', ''));
            },
            vh: function(value) {
                return (window.innerHeight / 100) * parseInt(value.replace('vh', ''));
            },
            '+': function(total, value) {
                return total + value;
            },
            '-': function(total, value) {
                return total - value;
            },
            '/': function(total, value) {
                return total / value;
            },
            '*': function(total, value) {
                return total * value;
            }
        };

        loop.object(data, function(object, i) {
            var value = data[object[i]];
            if (typeof data[object[i]] == 'object') {
                var calculation = [];
                loop.array(data[object[i]], function(array, j) {
                    if (typeof array[j] == 'string') {
                        if (arithmetic.indexOf(array[j]) > -1) {
                            calculation.push(array[j]);
                        } else {
                            loop.array(units, function(unit, k) {
                                if (array[j].indexOf(unit[k]) > -1) {
                                    calculation.push(fn[unit[k]](array[j]));
                                }
                            });
                        }
                    } else {
                        calculation.push(array[j]);
                    }
                });
                var total = 0;
                var method = null;
                loop.array(calculation, function(array, l) {
                    if (method == null) {
                        if (typeof array[l] == 'string') {
                            if (arithmetic.indexOf(array[l]) > -1) {
                                method = array[l];
                            }
                        } else {
                            total = array[l];
                        }
                    } else {
                        total = fn[method](total, array[l]);
                    }
                });

                value = total;
            }
            if (Soho.sizes[object[i]] !== false) {
                var breakpoint = Soho.breakpoints[Soho.sizes[object[i]]];

                if (window.matchMedia('(' + breakpoint.type + ': ' + breakpoint.size + 'px)').matches) {
                    padding = value;
                }
            } else {
                if (padding === false) {
                    padding = value;
                }
            }
        });

        return padding;
    }

    // Unset the active thumbnail
    this.unsetThumbnail = function() {
        var active = this.el.querySelector('[data-gallery-thumbnail-active="true"]');

        if (active) {
            active.removeAttribute('data-gallery-thumbnail-active');
        }
    }

    // Make a thumbnail active
    this.updateThumbnails = function(el) {
        this.unsetThumbnail();
        el.setAttribute('data-gallery-thumbnail-active', true);
    }

    // Check if carousel thumbnails exist
    this.checkIfThumbnailsExist = function(timeout) {
        timeout = timeout || 0;
        if (this.thumbnail[0]) {
            if (this.thumbnail[0].clientHeight > 0) {
                setTimeout(function() {
                    self.controlByThumbnail = true;
                    self.disableFocus();
                    self.controlClicked = true;
                    self.scroll();
                    self.updateThumbnails(self.thumbnail[self.id]);
                }, timeout);
            } else {
                this.controlByThumbnail = false;
            }
        }
    }

    // Watch the window for being resized
    this.watchForResize = function() {

        if (this.breakpoints === undefined) {
            return;
        }

        var windowResizing;

        window.addEventListener('resize', function() {
            clearTimeout(windowResizing);
            windowResizing = setTimeout(function() {
                self.checkBreakpoint({
                    breakpointChanged: function() {
                        self.checkIfThumbnailsExist(100);
                    }
                });
            }, 100);
        });
    }

    // Define the breakpoints to be taken into consideration for layout changes
    this.defineBreakpoints = function() {
        var data = JSON.parse(this.el.getAttribute('data-carousel-layout-check'));

        if (!data || data.length == 0) {
            return;
        }

        this.breakpoints = {};
        this.currentBreakpoint;

        loop.array(data, function(array, i) {
            self.breakpoints[array[i]] = Soho.breakpoints[Soho.sizes[array[i]]];
        });
    }

    // Check the current breakpoint
    this.checkBreakpoint = function(optionsOverride) {
        if (this.breakpoints === undefined) {
            return;
        }

        var breakpoint;
        var options = {
            breakpointChanged: function() {}
        };

        $.extend(options, optionsOverride);

        loop.object(self.breakpoints, function(object, i) {
            if (self.breakpoints[object[i]] !== undefined) {
                if (window.matchMedia('(' + self.breakpoints[object[i]].type + ': ' + self.breakpoints[object[i]].size + 'px)').matches) {
                    breakpoint = object[i];
                }
            } else {
                breakpoint = object[i];
            }
        });

        if (this.currentBreakpoint != breakpoint) {
            this.currentBreakpoint = breakpoint;

            if (typeof options.breakpointChanged == 'function') {
                options.breakpointChanged();
            }
        }
    }

    this.animate = function(destination, duration, easing, callback) {
        var duration = duration || 200;
        var easing = easing || 'linear';
        var easings = {
            linear: function(t) {
                return t;
            },
            easeInQuad: function(t) {
                return t * t;
            },
            easeOutQuad: function(t) {
                return t * (2 - t);
            },
            easeInOutQuad: function(t) {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            },
            easeInCubic: function(t) {
                return t * t * t;
            },
            easeOutCubic: function(t) {
                return (--t) * t * t + 1;
            },
            easeInOutCubic: function(t) {
                return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
            },
            easeInQuart: function(t) {
                return t * t * t * t;
            },
            easeOutQuart: function(t) {
                return 1 - (--t) * t * t * t;
            },
            easeInOutQuart: function(t) {
                return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
            },
            easeInQuint: function(t) {
                return t * t * t * t * t;
            },
            easeOutQuint: function(t) {
                return 1 + (--t) * t * t * t * t;
            },
            easeInOutQuint: function(t) {
                return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
            }
        };

        var start = self.container.scrollLeft;
        var startTime = new Date().getTime();

        if (destination < 0) {
            destination = 0;
        } else if (self.container.scrollWidth - this.container.clientWidth < destination) {
            destination = self.container.scrollWidth - this.container.clientWidth;
        }

        function scroll() {
            var now = new Date().getTime();
            var time = Math.min(1, ((now - startTime) / duration));
            var timeFunction = easings[easing](time);
            self.container.scroll(Math.ceil((timeFunction * (destination - start)) + start), 0);

            if (self.container.scrollLeft === destination) {
                if (callback) {
                    callback();
                }
                return;
            }

            requestAnimationFrame(scroll);
        }

        scroll();
    }
}

//=require tools/loop.js

Soho.carousels = [];

Soho.carousel = function() {
    var loop = new Loop();

    loop.array(document.querySelectorAll('.js-carousel'), function(array, i) {
        var carousel = new Carousel(array[i]);
        carousel.init();

        Soho.carousels.push(carousel);
    });
}


Soho.carousel();
